import React from 'react';
import { IconButton } from 'theme-ui';

function ExplorerFileShutterIcon() {
  return (
    <IconButton>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 12 12"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 7.5l-3-3-3 3"
        />
      </svg>
    </IconButton>
  );
}

export default ExplorerFileShutterIcon;
